
import PropTypes from 'prop-types';
import { Stack, Button, Text, Group, Box } from '@mantine/core';
import bedShapeOne from '../images/ui_buttons/bed_shape_1_button.png';
import bedShapeTwo from '../images/ui_buttons/bed_shape_2_button.png';
import bedShapeThree from '../images/ui_buttons/bed_shape_3_button.png';
import bedShapeFour from '../images/ui_buttons/bed_shape_4_button.png';
import bedShapeFive from '../images/ui_buttons/bed_shape_5_button.png';
import bedShapeSix from '../images/ui_buttons/bed_shape_6_button.png';
import bedShapeSeven from '../images/ui_buttons/bed_shape_7_button.png';
import bedShapeEight from '../images/ui_buttons/bed_shape_8_button.png';
import bedShapeNine from '../images/ui_buttons/bed_shape_9_button.png';
// bed-pipeline:shape-imports (new shape imports are inserted above this line by bed:generate)
import { colors, fontSize } from '../constants';
import { useAppContext } from '../context/AppContext';
import { availableShapes, availableSizes, sizeLabel } from '../lib/bedAvailability';

const { white } = colors;

const GardenBedButtonsMobile = ({
	selectedShape,
	selectedBedSize,
	onShapeClick,
	onSizeClick,
	showShapes,
	showSizes
}) => {
	const { state } = useAppContext();
	const style = state.currentDesign?.style;

	const shapeButtons = [
		{ id: 'bed_shape_1', image: bedShapeOne, alt: 'Bed Shape 1' },
		{ id: 'bed_shape_2', image: bedShapeTwo, alt: 'Bed Shape 2' },
		{ id: 'bed_shape_3', image: bedShapeThree, alt: 'Bed Shape 3' },
		{ id: 'bed_shape_4', image: bedShapeFour, alt: 'Bed Shape 4' },
		{ id: 'bed_shape_5', image: bedShapeFive, alt: 'Bed Shape 5' },
		{ id: 'bed_shape_6', image: bedShapeSix, alt: 'Bed Shape 6' },
		{ id: 'bed_shape_7', image: bedShapeSeven, alt: 'Bed Shape 7' },
		{ id: 'bed_shape_8', image: bedShapeEight, alt: 'Bed Shape 8' },
		{ id: 'bed_shape_9', image: bedShapeNine, alt: 'Bed Shape 9' },
		// bed-pipeline:shape-rows (new rows are inserted above this line by bed:generate)
	];

	const sizeOptions = availableSizes(selectedShape, style).map((size) => ({
		id: size,
		label: sizeLabel(selectedShape, size, style),
	}));

	return (
		<Box style={{ width: '100%', height: '100%' }}>
			{showShapes && (
				<Stack gap="0.5vh" style={{ height: '100%' }}>
					<Text style={{
						color: white,
						fontSize: fontSize.xxl,
						fontWeight: 'bold',
						textAlign: 'center',
            paddingTop: '1.5vh',
						marginBottom: '0vh'
					}}>
						Bed Shape
					</Text>
					
					<Box style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<Group gap="0.25vh" style={{ width: '100%', justifyContent: 'center' }}>
							{shapeButtons.filter((s) => availableShapes(style).includes(s.id)).map((shape) => (
								<Button
									key={shape.id}
									variant="filled"
									onClick={() => onShapeClick(shape.id)}
									styles={{
										root: {
											backgroundColor: selectedShape === shape.id ? colors.selectedLightGrey : colors.buttonColor,
											border: selectedShape === shape.id ? '0.25vh solid #475a46' : '0.25vh solid #666',
											borderRadius: '1.25vh',
											height: '12vw',
											width: '12vw',
											minHeight: '7.5vh',
											minWidth: '7.5vh',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											padding: 0,
											margin: 0
										}
									}}
								>
									<img src={shape.image} alt={shape.alt} style={{ width: '100%', height: 'auto', objectFit: 'cover' }} />
								</Button>
							))}
						</Group>
					</Box>
				</Stack>
			)}

			{showSizes && (
				<Stack gap="1.875vh" style={{ height: '100%' }}>
					<Text style={{
						color: white,
						fontSize: fontSize.xl,
						fontWeight: 'bold',
						textAlign: 'center',
						paddingTop: '1.5vh',
						marginBottom: '0vh'
					}}>
						Bed Size
					</Text>
					
					<Box style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						<Group gap="0.25vh" style={{ width: '100%', justifyContent: 'center' }}>
							{sizeOptions.map((size) => (
								<Button
									key={size.id}
									variant="filled"
									onClick={() => onSizeClick(size.id)}
									styles={{
										root: {
											backgroundColor: selectedBedSize === size.id ? colors.green : colors.buttonColor,
											//border: selectedBedSize === size.id ? '0.25vh solid #475a46' : '0.25vh solid #666',
											borderRadius: '1.25vh',
											height: '9.5vh',
											width: '22vw',
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center'
										}
									}}
								>
									<Text style={{
										fontSize: fontSize.lg,
										fontWeight: 'bold',
										color: colors.white
									}}>
										{size.label}
									</Text>
								</Button>
							))}
						</Group>
					</Box>
				</Stack>
			)}
		</Box>
	);
};

GardenBedButtonsMobile.propTypes = {
	selectedShape: PropTypes.string,
	selectedBedSize: PropTypes.number,
	onShapeClick: PropTypes.func.isRequired,
	onSizeClick: PropTypes.func.isRequired,
	showShapes: PropTypes.bool.isRequired,
	showSizes: PropTypes.bool.isRequired
};

export default GardenBedButtonsMobile;
